import { AfterContentInit, Directive, ElementRef, inject } from '@angular/core';
import $ from 'jquery';
import {get} from "lodash-es";

@Directive({
  selector: '[wmsTransclude]',
  standalone: true
})
export class WmsTranscludeDirective implements AfterContentInit {

  private _el: HTMLElement;
  constructor() {
    const elementRef = inject(ElementRef);
    this._el = elementRef.nativeElement;
  }

  getWidgetScopeId(widgetScope?: any): any {
    let parentElement;
    if (!get(this._el, 'widget')) {
      parentElement = get(this._el, 'parentElement');
    }
    if (!widgetScope) {
      parentElement = $(this._el).closest('[widget-id]')[0];
    }
    return parentElement?.getAttribute('widget-id') || '';
  }

  ngAfterContentInit() {
    let widgetId = this._el.getAttribute('widget-id') || this._el.getAttribute('widgetid');
    if (widgetId) {
      this._el.setAttribute('data-droptarget-for', widgetId);
    } else {
      let widgetScopeId = this.getWidgetScopeId();
      if (widgetScopeId) {
        this._el.setAttribute('data-droptarget-for', widgetScopeId);
      }
    }
  }
}
